<template>
  <div>
    <lazy-image
      :src="img_src"
      :lazy_src="lazy_img_src"
      alt="Slide image"
    />
  </div>
</template>

<script>

import MainSlideImageSlot from "../slots/MainSlideImageSlot.vue";
import LazyImage from "../small_parts/LazyImage.vue";

export default {
  name: "MainSlideFullHeightImage",
  components: {
    LazyImage,
    MainSlideImageSlot
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '/images/uploads-main-slide.jpeg',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    /**props**/
  },
}
</script>
